import { useMutation } from '@tanstack/react-query';

import { RemoveFunnelData } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const removeFunnel: RemoveFunnelData = (params) => {
  return axios.delete('/funnel', { params });
};

type QueryFnType = typeof removeFunnel;

type UseRemoveFunnelOptions = {
  pageId: string;
  config?: MutationConfig<
    (params: Omit<Parameters<QueryFnType>[0], 'pageId'>) => ReturnType<QueryFnType>
  >;
};

export function useRemoveFunnel({ config = {}, pageId }: UseRemoveFunnelOptions) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['funnels', pageId]);
    },
    ...config,
    mutationFn: ({ funnelId }) => removeFunnel({ funnelId, pageId }),
  });
}
